import { CashFlowFrameDialogService } from './cashFlowFrameDialogForm';

const cashFlowShoppingCart = {
  form: null,
  cashFlowFrameDialogService: null,
  init(options) {
    this.cashFlowFrameDialogService = new CashFlowFrameDialogService();
    const self = this;
    self.form = jQuery(options.formSelector);

    jQuery('.mainextstep2').click(() => {
      jQuery('.ca-loading-splash-container').css('display', 'block');
      jQuery('.overlay_layer').css('display', 'block');
      const ajaxlink = document.querySelector('#pmbForm').action;
      new Ajax.Updater('cart', ajaxlink, {
        method: 'post',
        parameters: {
          continue: 1,
        },
        evalScripts: true,
        onSuccess(transport) {
          /* Load html after after got response */
          jQuery('#module_ShoppingCart').hide();
          jQuery('.ca-loading-splash-container').css('display', 'none');
          jQuery('.overlay_layer').css('display', 'none');
          document.querySelector('#member-cart').innerHTML = transport.transport.response;
        },
        onFailure(transport) {
        },
      });
    });

    jQuery('.mainext').click(() => {
      jQuery('.ca-loading-splash-container').css('display', 'block');
      jQuery('.overlay_layer').css('display', 'block');
      const iframeContainer = document.querySelector('.iframe-container') ?? '';
      const { shadowRoot } = iframeContainer;
      let iframe = shadowRoot.querySelector("#tokenize-iframe-cashflow")
      const iframeSrc = iframe.getAttribute('src')
      iframe.contentWindow.postMessage({ eventName: 'cashFlowFormSubmit' }, iframeSrc);
      const addCardElement = document.querySelector('tokenize-payment-method');
      const userId = document.querySelector('input[name="user_id"]').value;
      const billStreetAddress = document.querySelector('input[name="bill_street_address"]').value ? document.querySelector('input[name="bill_street_address"]').value : 'address';
      const billCity = document.querySelector('input[name="bill_city"]').value ? document.querySelector('input[name="bill_city"]').value : 'city';
      const billState = document.querySelector('input[name="bill_state"]').value ? document.querySelector('input[name="bill_state"]').value : 'TX';
      iframe = addCardElement.shadowRoot.querySelector("#tokenize-iframe-cashflow");
      const serviceUri = iframe.getAttribute('service-uri');
      iframe.contentWindow.postMessage({ eventName: 'cashFlowFormSubmit' }, serviceUri);
      addCardElement.addEventListener('paymentAddedSuccess', (event) => {
        const account = document.querySelector('#account');
        const accountVal = account.value;
        const { cardholderName, expirationDate } = event.detail;
        const splitExpiryDate = expirationDate.split('/');
        let expirationMonth = splitExpiryDate[0];
        const year = this.cashFlowFrameDialogService.getFirstTwoDigitOfYear();
        const expirationYear = `${year}${splitExpiryDate[1]}`;
        const postalCode = event.detail.billingAddress.postalCode ?? '12345';
        if (expirationMonth.length === 1) {
          expirationMonth = `0${expirationMonth}`;
        }
        const ccDate = `${expirationYear}-${expirationMonth}-01`;
        const { lastFourDigits, token, cvv, brand } = event.detail;
        const firstDigit = this.cashFlowFrameDialogService.getFirstDigitByCreditType(brand);
        const ajaxlink = document.querySelector('#pmbForm').action;
        const paymentPlanVal = document.querySelector('input[name="use_payment_plan"]:checked')?.value ?? '0';
        new Ajax.Updater('cart', ajaxlink, {
          method: 'post',
          parameters: {
            user_id: userId,
            account: accountVal,
            cc_name: cardholderName,
            cc_number: `${firstDigit}***********${lastFourDigits}`,
            cc_track: '',
            cc_date: ccDate,
            bill_cvv: cvv,
            bill_zip: postalCode,
            bill_street_address: billStreetAddress,
            bill_street_address2: '',
            bill_city: billCity,
            bill_state: billState,
            cc_merchant_unique_id: token,
            continue: 1,
            gatewaySite: '',
            existingCard: '',
            currentRetailerId: '',
            cashflow_active: 1,
            use_payment_plan: paymentPlanVal,
          },
          evalScripts: true,
          onSuccess(transport) {
            /* Load html after after got response */
            jQuery('#module_ShoppingCart').hide();
            jQuery('.ca-loading-splash-container').css('display', 'none');
            jQuery('.overlay_layer').css('display', 'none');
            document.querySelector('#member-cart').innerHTML = transport.transport.response;
          },
          onFailure(transport) {
          },
        });
      });
      addCardElement.addEventListener('paymentAddedFailure', (event) => {
        if (typeof (event.detail.message) !== 'undefined') {
          const tokenizationErrorAlert = jQuery('.tokenization-error-alert');
          const caTitlebarClose = tokenizationErrorAlert.find('.ca-titlebar-close');
          caTitlebarClose.click();
          jQuery.caAlert(
              event.detail.message,
              '',
              {className: 'tokenization-error-alert'}
          );
        }
      });
    });
  },
};

export default cashFlowShoppingCart;